import Controller from '../abstracts/Controller';
import 'scss-templates/t-homepage.scss';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
      'InspiredComponent',
      'JournalComponent',
      'WishlistComponent',
      'EditorialCoverInfiniteComponent',
      'ManifestoComponent',
      'RecommendationEngineComponent',
      'GoogleRecommendationEngineComponent',
    ];
  }
}
